import React from 'react';
import classNames from 'classnames';

import propTypes from 'propTypes';

const Textarea = ({
  disabled,
  input,
  label,
  meta: { active, dirty, touched, error, warning },
  className,
  ...props
}) => {
  return (
    <div className={className}>
      <textarea
        className={classNames('Field__input', {
          'Field__input--disabled': disabled,
        })}
        disabled={disabled}
        placeholder={active ? '' : label}
        {...input}
        {...props}
      />
      {touched &&
        ((error && <div className="Field__error">{error}</div>) ||
          (warning && <div className="Field__warning">{warning}</div>))}
    </div>
  );
};

Textarea.propTypes = {
  disabled: propTypes.bool,
  input: propTypes.object.isRequired,
  label: propTypes.string,
  meta: propTypes.FormMeta.isRequired,
};

export default Textarea;



// WEBPACK FOOTER //
// ./app/javascript/common/components/Form/Textarea.js